import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../auth.service';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {ThemePalette} from '@angular/material/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {HelperService} from 'src/app/helper.service';
import {NavBarComponent} from '../../nav-bar/nav-bar.component';
import { ManagementService } from 'src/app/services/management.service';
import { CognitoService, IUser } from 'src/app/cognito.service';
import { BehaviorSubject } from 'rxjs';
import { User } from 'src/app/models/user';
import { user } from '@angular/fire/auth';
import { Role } from 'src/app/models/role';
import { Tenant } from 'src/app/models/tenant';
import {getCurrentUser, fetchAuthSession, JWT} from "aws-amplify/auth";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.css'],
    standalone: false
})
export class LandingComponent implements OnInit {

  public userSubject = new BehaviorSubject<User>(null);
  user$ = this.userSubject.asObservable();

  public tenantsSubject = new BehaviorSubject<Tenant[]>(null);
  tenants$ = this.tenantsSubject.asObservable();
  userResponse: JWT;

  public rolesSubject = new BehaviorSubject<Role[]>(null);
  roles$ = this.rolesSubject.asObservable();

  public setBackgroundActive = false;
  public mode: ProgressSpinnerMode = 'indeterminate';
  myCustomColor: ThemePalette = 'primary';
  myCustomValue = 50;

  public termsAndConditionsUrl = environment.termsAndConditionsUrl;
  public privacyPolicyUrl = environment.privacyPolicyUrl;
  public publicFacingUrl = environment.publicFacingUrl;
  public environment = environment;

  welcomeTitel: string = '';

  constructor(public auth: AuthService,
    public translate: TranslateService,
    public router: Router,
    public projectTitle: Title,
    public managementService: ManagementService,
    private spinner: NgxSpinnerService,
    private helper: HelperService,
    public nav: NavBarComponent,
    private cognitoService: CognitoService
  ) {
  }

  ngOnInit(): void {
    this.checkAuthLoading();
    // this.spinner.show();
    if (this.projectTitle.getTitle().toLowerCase().includes('SGS Precision Gateway'.toLocaleLowerCase())) {
        this.setBackgroundActive = true;
    } else {
        this.setBackgroundActive = false;
    }
    if (this.auth.loggedIn) {
      this.checkLoggedIn();

      this.router.navigate(['/mapping']);
    }
  }

  async checkLoggedIn() {
    const user = await this.auth.getUser$();

    // console.log(user)

    this.managementService.getUserRequest(user.signInDetails.loginId).subscribe((user) => {
      this.auth.userSubject.next(user);
      let jsonUser = JSON.stringify(user);
      sessionStorage.setItem("user", jsonUser);

      setTimeout(() => {
        this.managementService.getUserTenants(user.id).subscribe((tenants) => {
          tenants.sort((a, b) => a.name.localeCompare(b.name));
          this.auth.tenantsSubject.next(tenants);
          let jsonTenants = JSON.stringify(tenants);
          sessionStorage.setItem("tenants", jsonTenants);
        })
      }, 1000);

      this.managementService.getUserRoles(user.id).subscribe(roles => {
        this.auth.rolesSubject.next(roles);
        let jsonRoles = JSON.stringify(roles);
        sessionStorage.setItem("roles", jsonRoles);
        this.router.navigate([user.landingPage]);
      });
    });
  }

  async login () {
    this.router.navigate(['/login']);
  }

  async register() {
    this.router.navigate(['/registration']);
  }
  checkAuthLoading(){
    if(this.auth.isBusy){
      this.nav.toggleLoading(true);
    }else{
      this.nav.toggleLoading(false);
    }
  }
  setBackground(): string{
    return JSON.stringify(environment.theme.background);
  }
    
  getWelcometitle(): string{
    this.welcomeTitel = environment.theme.welcomeTitle;
    return this.welcomeTitel;
  }

}
